<template>
  <!-- -->
  <div class="product-category">
    <div class="desc">
      商品列表为系统固定组件，不可修改样式，但可以自定义分类选中样式
    </div>
    <form-items label-width="2.4rem" :columns="1">
      <form-item label="选中颜色">
        <el-color-picker v-model="settingData.activeColor" show-alpha @change="changeData"/>
      </form-item>
    </form-items>
  </div>
</template>

<script>


import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";

export default {
  emits: ["change"],
  props: {
    data: {
      type: Object,
      default: () => {
        return {componentData: {}}
      }
    }
  },
  name: "",
  components: {
    FormItem, FormItems
  },
  data() {
    return {
      settingData: {},
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!this.data.componentData || !this.data.componentData.itemImage) {
        this.settingData = {size: ""};
      } else {
        this.settingData = this.data.componentData;
      }
    },
    changeData() {
      this.$emit("change", {...this.data, componentData: this.settingData});
    }
  }
};
</script>

<style lang="scss" scoped>
.product-category{
}
</style>